import { TLocalizationFormValues } from './LocalizationForm.types';

export const STATIC_LOCALIZATION_FORM_DEFAULT_VALUES: TLocalizationFormValues =
  {
    key: '',
    value: '',
  };
